export var AccountType;
(function (AccountType) {
    AccountType[AccountType["Uninitialized"] = 0] = "Uninitialized";
    AccountType[AccountType["Mint"] = 1] = "Mint";
    AccountType[AccountType["Account"] = 2] = "Account";
})(AccountType || (AccountType = {}));
export const ACCOUNT_TYPE_SIZE = 1;
//# sourceMappingURL=accountType.js.map